import { z } from "zod";

/// Profile page tabs: released review history only, today.
///
/// "security" and "summary" both left when settings was consolidated: the
/// password card and the About/Role detail live at `/settings/profile`, and
/// keeping second copies here was exactly the duplication that consolidation
/// existed to remove. Old links to either are harmless rather than broken,
/// via the schema's `.catch` below.
///
/// Kept as an array rather than collapsed to a bare route because reviews is
/// unlikely to stay the only thing a member reads about themselves.
export const PROFILE_TABS = ["reviews"] as const;
export type ProfileTab = (typeof PROFILE_TABS)[number];

export const profileSearchSchema = z
  .object({
    tab: z.enum(PROFILE_TABS).default("reviews").catch("reviews"),
  })
  .strict();
export type ProfileSearch = z.infer<typeof profileSearchSchema>;
